import React from "react";
import "./sema.scss";
import { ArrowButton } from "../../components/arrow-button";
import { PhotoColumn } from "../../components/photo-column";
import SemaninSonHali from '../../assets/photos/sema/semanin-son-hali-640.jpg';

interface SemaSonHaliProps {
    isVisible: boolean;
    comeBackSemaSection: Function;
}
interface SemaSonHaliState {
    Change: boolean;
}


class SemaSonHali extends React.Component<SemaSonHaliProps, SemaSonHaliState> {
    constructor(props: any) {
        super(props);
        this.state = {
            Change: true
        };
    }

    render() {
        return (
            <div style={{ display: this.props.isVisible ? "block" : "none" }}>
                <article>
                    <ArrowButton onClick={this.props.comeBackSemaSection} />
                    <h3 className="title">KONYA'DA SEMA’NIN SON HALİNİ ALMASI</h3>
                    <PhotoColumn
                        imageSource={SemaninSonHali}
                        imageTitle="Sema'nın Sol Halini Alması"
                        figcaptionFirstTitle="Postnişin Selman Dede ve Celaleddin Bakır Çelebi"
                    />
                    <p>
                        Sultanü’l-Ulema, Mevlana, Hüsameddin Çelebi ve Sultan Veled müderris bulundukları medresenin bir odasında
                        diledikleri vakit zikrederler, başka tekkelerin ayinlerine katılırlar, evlerde sema, sohbet meclisleri
                        kurarlardı, kendikerine mahsus tekkeleri yoktu. Sayıları 10 kişiyi geçmezdi. İlk defa Ulu Arif Çelebi
                        dedesinin türbesinde uzlete çekilmesiyle, mevlevihanenin nüvesi meydana atılmış oldu. Mevleviliğin en önemli
                        esası <span className="highlight-word">SEMA</span>’dır. Yukarıda izah edilmeye çalışıldığı gibi Hz. Mevlâna zamanında <span className="highlight-word">SEMA</span>, bir dost toplantısı, bir
                        yemek meclisi evvelinde veya sonunda, kulağa gelen hoş ve manalı bir ses veya heyecanlı bir hadise neticesinde
                        ortaya çıkan VECD hali idi. Bu devirlerde muhtelif hadiselerin tesirleri ile <span className="highlight-word">SEMA</span>’nın yanında, bir musiki
                        heyetinin de refakati ile toplu halde ve çoğu zamanda tesadüfe bağlı <span className="highlight-word">SEMA</span>’da yapılırdı. Kaynaklarda bu şekilde
                        icra edilen <span className="highlight-word">SEMA</span>’nın teferruatına rastlanmaz. Ancak bazı kayıtlardan bilhassa Mevlâna’nın medresesinde yapılan
                        <span className="highlight-word"> SEMA</span> da musiki heyetine ayrılan yüksekçe bir yer bulunduğu Mevlâna’nın tamamen erkeklerden müteşekkil olan bu
                        heyetin önünde <span className="highlight-word">SEMA</span> ettiği olmuştur. Yine <span className="highlight-word">SEMA</span>’nın sonraki şeklinde görülen selam verme âdetinin izlerine de
                        rastlanmaktadır.
                    </p>

                    <p>
                        Mevlâna zamanında ve onu takip eden devirde daha önceleri <span className="highlight-word">SEMA</span> adabından sayılan ‘zaman, mekân, imkân ve
                        ihvan’a çok defa ehemmiyet verilmediği görülmektedir. Mevlâna’nın vefatından sonra halefi Hüsameddin Çelebi
                        tarafından Cuma namazını müteakip, Kur’an okunduktan sonra, toplu bir halde <span className="highlight-word">SEMA</span> yapılması bir gelenek haline
                        getirildi. Bununla beraber belirli bir zaman ve mekâna bağlı kalmaksızın, muhtelif vesileler ile <span className="highlight-word">SEMA </span>
                        yapıldığı da rivayet buyurulmaktadır.
                    </p>

                    <p>
                        <span className="highlight-word">SEMA</span>’nın bilhassa Mevlevi tekkelerinde adab ve erkâna riayet edilerek bir ayin halinde icra edildiğinin hangi
                        tarihte başladığı bilinmemektedir.
                    </p>

                    <p>
                        Mevlevi Ayini, Hz. Mevlâna tarafından tamamen bir VECD halinin ifadesi olarak, bir usul ve merasime bağlı
                        olmaksızın yapılan <span className="highlight-word">SEMA</span>’nın, bir düzene bağlanması ile oluşmuştur. Hz. Mevlâna’nın düşünce, fikir, yaşayış,
                        ilim, aşk ve cezbesinin, bir tasavvuf ekolü halinde ortaya çıkışı, oğlu Sultan Veled zamanında olmuştur.
                        Sultan Veled ve hatta oğlu Ulu Arif Çelebi, aynen Hz. Mevlâna gibi, belli bir düzen olmadan, coşkunlukla <span className="highlight-word">SEMA </span>
                        ederlerdi. Ancak ayrıca Cuma namazından sonra Hz. Mevlâna’yı anmak maksadı ile tertiplenen toplantılar, ayinin
                        bir düzen halinde ortaya çıkmasına sebep teşkil etmiş ve <span className="highlight-word">SEMA</span> meclislerine belli bir düzen verilmeye
                        başlanmıştır. Ayin, önce Pir Adil Çelebi ve daha sonra da Pir Hüseyin Çelebi tarafından bugünkü şekil ve
                        düzenine konulmuştur. Pir Adil Çelebi; Sultan Veled’in (ölüm Miladi 12 Ksım 1312 / Hicri 11 Recep 712) oğlu
                        Şemseddin Emir Abid Çelebi’nin (ölüm Miladi 23 Temmuz 1338 / Hicri 4 Muharrem 739) oğlu Emir Âlim Çelebi’nin
                        (ölüm Miladi 1350 / Hicri 751) oğludur.
                    </p>

                    <p>
                        Feridun Ulu Arif Çelebi’nin (ölüm Miladi 5 Kasım 1328 / Hicri 2 Şevval 720) oğlu Muzaffereddin Ekber Emir Adil
                        Çelebi’nin (ölüm Miladi 1368 / Hicri 770) oğlu olan II. Arif Çelebi’nin Miladi 1421 / Hicri 824’de vefatı ile
                        Çelebilik makamına geçmiş, Miladi 1460 / Hicri 865 yılından vefatına kadar 39 yıl bu görevde kalmıştır. <span className="highlight-word">SEMA </span>
                        ayinine bugünkü şeklini veren bu zattır. En son şekillendirme ve teferruat düzenlemesi ise, Afyonkarahisar’lı
                        3. Arif Çelebi’nin (Küçük Arif Çeleci) Miladi 1642 / Hicri 1052 yılında vefatı ile Çelebilik makamına geçen ve
                        Ferruh Çelebi’nin (ölüm Miladi 1591 / Hicri 1000) oğlu olan Hasan Çelebi’nin oğlu Pir Hüseyin Çelebi (ölüm
                        Miladi 1666 / Hicri 1077) tarafından yapılmıştır. Konya’daki Asitane’nin (Pir Evi) 18. postnişini olan Pir
                        Hüseyin Çelebi, Tekke-Medrese kavgasının en ateşli zamanları olan Sivasiler-Kadızadeler kavgasını görmüş,
                        yaşamış ve bu tesirle de Mevlevi <span className="highlight-word">SEMA</span> ayinini, cahiller ve inatların dışında, herkesin kabulüne mazhar bir
                        düzenle ortaya koymuştur.
                    </p>
                </article>
            </div>
        );
    }
}

export default SemaSonHali;